// LIBRERIE/IMPORTS
import React from "react";
import { useTranslation } from "react-i18next";

interface Agent {
    img: string;
    name: string;
    tel?: string;
    mobile?: string;
    email?: string;
}

interface AgentsSectionProps {
    showAgents: boolean;
    agents: Agent[];
    agentsLoading: boolean;
    agentsError: string | null;
}

const AgentsSection: React.FC<AgentsSectionProps> = ({ showAgents, agents, agentsLoading, agentsError }) => {
    const { t } = useTranslation();

    if (!showAgents) return null;

    return (
        (agentsLoading || agentsError || agents.length > 0) ? (
            <section className="space-pb pt-5">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="section-title text-center">
                                <h2>{t('agents.sectionTitle')}</h2>
                                <p>{t('agents.subTitle')}</p>
                            </div>
                        </div>
                    </div>

                    {agentsLoading ? (
                        <div className="text-center">{t('agents.loadingAgents')}...</div>
                    ) : agentsError ? (
                        <div className="text-center text-danger">{agentsError}</div>
                    ) : (
                        <div className="row no-gutters justify-content-center">
                            {agents.map((agent, index) => (
                                <div key={index} className="col-lg-3 col-md-4 col-sm-6 mb-4">
                                    <div className="agent text-center h-100">
                                        <div className="agent-detail p-3 border rounded d-flex flex-column h-100">
                                            <div className="agent-avatar avatar avatar-xllll mx-auto">
                                                <img className="img-fluid rounded-circle" src={agent.img || '/assets/images/placeholder_agent.png'} alt={agent.name} /> {/* Placeholder se img manca */}
                                            </div>
                                            <div className="agent-info mt-3 flex-grow-1">
                                                <h6 className="mb-0">{agent.name}</h6>
                                                <ul className="list-unstyled mt-3">
                                                    {agent.tel && (
                                                        <li>
                                                            <strong>{t('agents.labelTel')} </strong>
                                                            <a href={`tel:${agent.tel}`} title={`${t('agents.agentTelTitle')} ${agent.name}`}>
                                                                {agent.tel}
                                                            </a>
                                                        </li>
                                                    )}
                                                    {agent.mobile && (
                                                        <li>
                                                            <strong>{t('agents.labelMobile')} </strong>
                                                            <a href={`tel:${agent.mobile}`} title={`${t('agents.agentMobTitle')} ${agent.name}`}>
                                                                {agent.mobile}
                                                            </a>
                                                        </li>
                                                    )}
                                                    {agent.email && (
                                                        <li>
                                                            <strong>{t('agents.labelEmail')} </strong>
                                                            <a href={`mailto:${agent.email}`} title={`${t('agents.agentMailTitle')} ${agent.name}`}>
                                                                {agent.email}
                                                            </a>
                                                        </li>
                                                    )}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </section>
        ) : null
    );
};

export default AgentsSection;